import React from "react";
import { Text, Tooltip } from "@chakra-ui/react";
import { faxMatchedVisitDate } from "../../utils/faxReportPath";

/**
 * Says only one thing now: that this fax reached a patient with no visits.
 *
 * It used to also show "📅 Matched to visit: Jul 25, 2026" for the normal case.
 * That was removed (2026-09-02) because the schema badges next to it already
 * list the matched date PER SCHEMA, and the clinic-group fan-out puts the same
 * fax on a different appointment in each one — so a single date beside them was
 * at best redundant and at worst named a different visit than the badges did.
 *
 * The no-visits case survives because nothing else says it: the fax is filed
 * against the chart rather than an appointment, and a clinician looking for it
 * on a visit would not find it. When the list's endpoint doesn't resolve dates,
 * `has_scheduled_visit` is absent and this renders nothing rather than guess.
 */
export const FaxMatchedDate = ({ fax }) => {
  if (!fax || fax.is_unmatched) return null;
  if (faxMatchedVisitDate(fax)) return null;
  if (fax.has_scheduled_visit !== false) return null;

  return (
    <Tooltip label="No scheduled visit was found for this patient, so the fax is filed against their chart. It shows under the patient's Reports, and on their next visit once one is booked.">
      <Text
        fontSize="xs"
        color="gray.600"
        bg="gray.100"
        px={2}
        py={0.5}
        borderRadius="md"
      >
        📁 Patient chart — no scheduled visits
      </Text>
    </Tooltip>
  );
};

export default FaxMatchedDate;
